import type {
  GetGasConsumptionResponse,
  GetGasInjectionAndWithdrawalChartParams,
  GetGasInjectionAndWithdrawalChartResponse,
  GetGasStorageChartParams,
  GetGasStorageChartResponse,
  GetMarketMonitoringPowerGenerationChartParams,
  GetMarketMonitoringPowerGenerationChartResponse,
  GetNationalNuclearAvailabilityResponseResponse,
  GetNationalThermalChartParams,
  GetNationalThermalChartResponse,
} from "$/lib/types/api/market-monitoring/fundamentals.types";
import { restApiClient } from "../restApiClient";

export const getPowerGenerationChart = async (
  params: GetMarketMonitoringPowerGenerationChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/fundamentals/power-generation-chart")
    .query({ ...params })
    .get<GetMarketMonitoringPowerGenerationChartResponse>();
};

export const getGasStorageChart = async (params: GetGasStorageChartParams) => {
  return restApiClient
    .url("/market-monitoring/fundamentals/gas-storage")
    .query({ ...params })
    .get<GetGasStorageChartResponse>();
};

export const getGasInjectionAndWithdrawalChart = async (
  params: GetGasInjectionAndWithdrawalChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/fundamentals/gas-injection-withdrawal-chart")
    .query({ ...params })
    .get<GetGasInjectionAndWithdrawalChartResponse>();
};

export const getNationalThermalChart = async (
  params: GetNationalThermalChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/fundamentals/national-thermal-chart")
    .query({ ...params })
    .get<GetNationalThermalChartResponse>();
};

export const getNuclearPlantsAvailability = async () => {
  return restApiClient
    .url("/market-monitoring/fundamentals/nuclear-plants-availability")
    .get<GetNationalNuclearAvailabilityResponseResponse>();
};

export const getGasConsumption = async () => {
  return restApiClient
    .url("/market-monitoring/fundamentals/gas-consumption")
    .get<GetGasConsumptionResponse>();
};
